"use client"

import { OptimizedMediaType } from "@/app/types/media";
import { Backdrop, Box, CircularProgress, colors, Grid2 as Grid } from "@mui/material";
import MediaV2 from "@v2/components/MediaV2";
import { Suspense, useState } from "react";

import { Maximize } from "lucide-react";
import dynamic from "next/dynamic";

export default function PdpDesktopGallery({ images, details }: {
    images: OptimizedMediaType[],
    details: {
        title: string,
        color_code: string,
        supersede_alt: string
    }
}) {
    const [fullScreenGalleryIsShow, setFullScreenGalleryIsShow] = useState<null | number>(null)

    const PdpDesktopFullscreenGallery = dynamic(() => import("./PdpDesktopFullscreenGallery"), {
        ssr: false,
        loading: () => <Backdrop open sx={{ zIndex: 1600 }}><CircularProgress /></Backdrop>,
    });

    return <>
        {(fullScreenGalleryIsShow !== null) && (
            <Suspense>
                <PdpDesktopFullscreenGallery
                    images={images}
                    details={details}
                    show={fullScreenGalleryIsShow}
                    onClose={() => setFullScreenGalleryIsShow(null)}
                />
            </Suspense>
        )}
        <Grid container spacing={0.5} sx={{}}>
            {images.map((media, index) => {

                const isFirst = index === 0;
                const isLast = index === images.length - 1
                const isFull = isFirst || ((index % 2 === 1) && isLast);
                const hasPriority = index < 3;

                const width = isFull ? 1020 : 508;
                const height = isFull ? 630.41 : 313.96;

                return (
                    <Grid size={isFirst ? 12 : isLast ? 'grow' : 6} key={`${index}-${media.id}`} sx={{
                        position: 'relative',
                        cursor: 'pointer'
                    }} >
                        <MediaV2
                            media_id={media.id}
                            alt={media.alt ?? details.supersede_alt + " - عکس شماره " + (index + 1)}
                            imageProps={{
                                fill: true,
                                priority: hasPriority,
                                loading: hasPriority ? 'eager' : 'lazy',
                                fetchPriority: hasPriority ? 'high' : 'auto',

                                style: {
                                    objectFit: 'cover',
                                    pointerEvents: 'none'
                                },
                                onLoad: (e: any) => e.target.classList.add('loaded')
                            }}
                            width={width}
                            height={height}

                            boxProps={{
                                onClick: () => setFullScreenGalleryIsShow(index),
                                sx: {
                                    borderRadius: 1,
                                    width: '100%',
                                    aspectRatio: '1.618 / 1',
                                    bgcolor: colors.grey[200],
                                    ...(!hasPriority ? {
                                        '& img': {
                                            opacity: 0,
                                            transition: '280ms',
                                            transform: 'scale(1.1)',
                                            '&.loaded': {
                                                opacity: 1,
                                                transform: 'scale(1)',

                                            }
                                        }
                                    } : {})
                                }
                            }} />
                        <Box onClick={() => setFullScreenGalleryIsShow(index)} sx={{
                            position: 'absolute',
                            right: 16,
                            bottom: 16,
                            zIndex: 2,
                            '&:hover': {
                                '& > i': {
                                    color: colors.grey[900]
                                }
                            }
                        }}>
                            <Maximize size={18} color={colors.grey[500]} />
                        </Box>
                    </Grid>
                )
            })}
        </Grid>
    </>
}
